/** Bind the cancellable SDK adapter to this client's read-only Storage endpoint. */
export function storageInfoFetch(endpoint: string, signal: AbortSignal): typeof fetch {
  const origin = new URL(endpoint).origin;
  const allowedOrigins = new Set([origin]);
  const prefix = "/storage/v1/object/info/documents/";
  return async (input, init) => {
    signal.throwIfAborted();
    // Parsed only for its URL, method and headers. The caller's signal is left
    // out: the read is cancelled by the task signal below, and Node's Request
    // refuses an AbortSignal from another realm (jsdom's, under the test runner).
    const request = new Request(input, init ? { ...init, signal: null } : undefined);
    const candidate = new URL(request.url);
    if (!candidate.pathname.startsWith(prefix)) {
      throw new Error("Storage request outside the configured endpoint");
    }
    if (request.method !== "GET") throw new Error("Storage metadata reads require GET");
    if (allowedOrigins.has(candidate.origin)) {
      // Reconstruct the destination from the trusted origin and fixed API prefix.
      // Redirects cannot forward this client's authorization to another endpoint.
      const destination = new URL(prefix, origin);
      destination.pathname += candidate.pathname.slice(prefix.length);
      destination.search = candidate.search;
      return fetch(destination.href, {
        ...init,
        method: "GET",
        headers: request.headers,
        signal,
        redirect: "error",
      });
    }
    throw new Error("Storage request outside the configured endpoint");
  };
}
